export const paymentDetailsByType = {
  payment_cash: [
    'cash_name',
    'amount',
    'amount_used',
    'currency',
    'client_name',
    'client_document_type',
    'client_document_number',
  ],
  payment_bank: ['bank_name', 'coupon_number', 'date_time', 'amount', 'amount_used', 'currency'],
  payment_online: [
    'amount',
    'amount_used',
    'vendor_code',
    'card_number',
    'quota',
    'bank_name',
    'expiry_date',
    'transaction',
    'agency_auth_code',
  ],
  payment_paypal: [
    'paypal_id',
    'status_detail',
    'payer.name.surname',
    'amount',
    'amount_used',
    'currency',
    'date_time',
  ],
  payment_braspag: [
    'card_number',
    'authorization_code',
    'installments',
    'card_holder',
    'card_brand_name',
    'customer_street',
    'customer_number',
    'customer_city',
    'customer_state',
    'customer_country',
    'customer_district',
    'customer_complement',
    'customer_zip_code',
  ],
  payment_pix: [
    'customer_document_type',
    'customer_document_value',
    'customer_name',
    'tx_id',
    'order_id',
    'date_time',
  ],
  expenses: ['name', 'amount_used'],
}
